import { render } from "./FPSCounter.vue?vue&type=template&id=27eb1626&scoped=true"
import script from "./FPSCounter.vue?vue&type=script&lang=js"
export * from "./FPSCounter.vue?vue&type=script&lang=js"

import "./FPSCounter.vue?vue&type=style&index=0&id=27eb1626&scoped=true&lang=css"

import exportComponent from "/Users/tirinox/Projects/thorviz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27eb1626"]])

export default __exports__